<template>
    <div id="wuPage" class="questionBank">
        <a-table ref="table" bordered size="middle" rowKey="id" :columns="columns" :dataSource="dataSource"
            :pagination="ipagination" :loading="loading" @change="handleTableChange">
            <span slot="esContent" slot-scope="text">
                <j-ellipsis :value="text" :length="30" />
            </span>
            <template slot="htmlSlot" slot-scope="text">
                <a-popover title="题干预览" placement="right">
                    <div slot="content" v-html-md="text"></div>
                    <a-icon type="eye" theme="twoTone" />
                </a-popover>
            </template>

            <template slot="codeSlot" slot-scope="text">
                <a-popover v-if="text" title="代码预览" placement="right">
                    <pre slot="content">{{ getAnswerCode(text) }}</pre>
                    <a-icon type="eye" theme="twoTone" />
                </a-popover>
                <span v-else>暂无</span>
            </template>

            <template slot="testCaseSlot" slot-scope="text">
                <a-popover v-if="text" placement="left">
                    <div slot="content" style="width: 400px">
                        <a-card>
                            <a-row>
                                <a-col :span="10">用例名称</a-col>
                                <a-col :span="6">得分</a-col>
                                <a-col :span="6">结果</a-col>
                            </a-row>
                            <a-divider></a-divider>
                            <a-row v-for="(c, i) in getTestCase(text)" :key="i">
                                <a-col :span="10">{{ c.name }}</a-col>
                                <a-col :span="6">{{ c.gotScore }}</a-col>
                                <a-col :span="6">{{ c.gotScore == 0 ? '失败' : '通过' }}</a-col>
                            </a-row>
                        </a-card>
                    </div>
                    <a-icon type="eye" theme="twoTone" />
                </a-popover>
                <span v-else>暂无</span>
            </template>

            <span slot="action" slot-scope="text, record">
                <a @click="toQuestion(record)">查看</a>
            </span>
        </a-table>
    </div>
</template>

<script>
import { JeecgListMixin } from "@/utils/JeecgListMixin";
import { getAction } from "@/api/manage";
import JEllipsis from "@/components/jeecg/JEllipsis";
export default {
    name: "questionBank",
    mixins: [JeecgListMixin],
    components: {
        JEllipsis
    },
    data() {
        return {
            columns: [
                {
                    title: "#",
                    dataIndex: "",
                    key: "rowIndex",
                    width: 60,
                    align: "center",
                    customRender: function (t, r, index) {
                        return parseInt(index) + 1;
                    },
                },
                {
                    title: '得分',
                    align: 'center',
                    width: 80,
                    dataIndex: 'gotScore',
                    customRender(v) {
                        if (v == -1) {
                            return '待批改'
                        } else {
                            return v
                        }
                    },
                },
                {
                    title: '批改时间',
                    align: 'center',
                    width: 180,
                    dataIndex: 'reviewTime',
                    customRender(v) {
                        if (v) {
                            return v
                        } else {
                            return '待批改'
                        }
                    },
                },
                {
                    title: '代码',
                    align: 'center',
                    dataIndex: 'myAnswer',
                    width: 100,
                    scopedSlots: { customRender: 'codeSlot' },
                },
                {
                    title: '测试用例',
                    align: 'center',
                    dataIndex: 'testCase',
                    width: 100,
                    scopedSlots: { customRender: 'testCaseSlot' },
                },
                {
                    title: "分值",
                    align: "center",
                    width: 80,
                    dataIndex: "questionScore",
                },
                // {
                //     title: "操作",
                //     dataIndex: "action",
                //     fixed: "right",
                //     align: "center",
                //     width: 150,
                //     scopedSlots: { customRender: "action" },
                // },
            ],
            url: {
                list: "/teaching/teachingQuestion/getMyPublicAnswerList",
            },
            disableMixinCreated: true, //禁用mixin的created方法
            unitInfo: {},
            queryParam: {
                questionId: ''
            },
        };
    },
    created() {
        if (this.$route.query.id) {
            this.queryParam.questionId = this.$route.query.id
        }
        this.loadData(1);
    },
    methods: {
        toQuestion(q) {
            console.log(q, 'qqqq')
            window.open("/onlinecode/index.html?questionId=" + q.questionId);
        },
        getTestCase(text) {
            return JSON.parse(text)
        },
        getAnswerCode(text) {
            return JSON.parse(text).files[0].content
        }
    },
};
</script>

<style>
.questionBank {
    padding: 20px;
}
</style>